import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BUCKETWISE_ALLOCATION_API = "portfolio/bucket-wise-allocation";
const BUCKETWISE_STATUS_API = "portfolio/bucket-status";


export const fetchBucketWiseAllocation = createAsyncThunk(
    "bankDetails/fetchBucketWiseAllocation",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const validUser = state.auth.user;
            if (!token || !validUser?.is_agency) {
                return;
            }

            const response = await axios.get(`${BUCKETWISE_ALLOCATION_API}/${params?.portfolio_id}/`, {
                // params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);
export const fetchBucketWiseStatus = createAsyncThunk(  
    "bankDetails/fetchBucketWiseStatus",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            const validUser = state.auth.user;
            if (!token || !validUser?.is_agency) {
                return;
            }
          

            const response = await axios.get(`${BUCKETWISE_STATUS_API}/${params?.portfolio_id}/`, {
                // params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);


const initialState = {
    // bucket wise allocation
    bucketwise_allocation: [],
    bucketwise_loading: false,

    // bucket wise status
    bucketwise_status: [],
    bucketwise_status_loading: false,
};


const bucketwiseAllocationSlice = createSlice({
    name: "bucketwise",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            // bucket wise allocation

            .addCase(fetchBucketWiseAllocation.pending, (state) => {
                state.bucketwise_loading = true;
            })
            .addCase(fetchBucketWiseAllocation.fulfilled, (state, action) => {
                state.bucketwise_loading = false;
                state.bucketwise_allocation = action.payload;
            })
            .addCase(fetchBucketWiseAllocation.rejected, (state, action) => {
                state.bucketwise_loading = false;
                state.bucketwise_allocation = [];
            })

            // bucket wise status

            .addCase(fetchBucketWiseStatus.pending, (state) => {
                state.bucketwise_status_loading = true;
            })
            .addCase(fetchBucketWiseStatus.fulfilled, (state, action) => {
                state.bucketwise_status_loading = false;
                state.bucketwise_status = action.payload;
            })
            .addCase(fetchBucketWiseStatus.rejected, (state, action) => {
                state.bucketwise_status_loading = false;
                state.bucketwise_status = [];
            });
    },
});

export default bucketwiseAllocationSlice.reducer;
